<!-- 最小流量 -->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('选择日期')">
              <a-date-picker v-model="queryParam.date" value-format="YYYY-MM-DD" style="width: 100%"></a-date-picker>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        :scroll="{ x: true }"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="normal" slot-scope="text, record">
          <a style="color: #2db7f5">{{ text }}</a>
        </template>
        <template slot="abnormal" slot-scope="text, record">
          <a style="color: orange">{{ text }}</a>
        </template>
        <template slot="connectionAbnormal" slot-scope="text, record">
          <a style="color: red">{{ text }}</a>
        </template>

        <template slot="dmaNormal" slot-scope="text, record">
          <a style="color: #2db7f5">{{ text }}</a>
        </template>
        <template slot="dmaAbnormal" slot-scope="text, record">
          <a style="color: orange">{{ text }}</a>
        </template>
        <template slot="dmaConnectionAbnormal" slot-scope="text, record">
          <a style="color: red">{{ text }}</a>
        </template>

        <template slot="dmaFocus" slot-scope="text, record">
          <a style="color: #2db7f5">{{ text }}</a>
        </template>
      </a-table>
    </div>
  </a-card>
</template>
    
    <script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getAction } from '@/api/manage'
import CONFIG from '@/views/DMAPartitionMetering/PipelineNetMap/module/config/GIS_Config.js'
import Vue from 'vue'

export default {
  name: 'MinimumFlowRate',
  mixins: [JeecgListMixin, mixinDevice],
  components: {},
  data() {
    return {
      description: '最小流量',
      CONFIG,
      url: {
        list: '/jeecg-gis/area/minFlowRateStatistics',
      },
      dictOptions: {},
      superFieldList: [],
    }
  },
  created() {
    this.loadTopologyParams()
  },
  computed: {
    // i18n：表头使用 computed 以响应语言切换
    columns() {
      return [
        {
          title: this.$t('序号'),
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('一级分区名称'),
          align: 'center',
          dataIndex: 'areaName1',
        },
        {
          title: this.$t('二级分区流量计'),
          align: 'center',
          children: [
            {
              title: this.$t('总数'),
              align: 'center',
              dataIndex: 'total2',
            },
            {
              title: this.$t('正常数'),
              align: 'center',
              dataIndex: 'alarm21',
              scopedSlots: { customRender: 'normal' },
            },
            {
              title: this.$t('警告数'),
              align: 'center',
              dataIndex: 'alarm22',
              scopedSlots: { customRender: 'abnormal' },
            },
            {
              title: this.$t('严重数'),
              align: 'center',
              dataIndex: 'alarm23',
              scopedSlots: { customRender: 'connectionAbnormal' },
            },
            {
              title: this.$t('无效数'),
              align: 'center',
              dataIndex: 'alarm20',
            },
          ],
        },
        {
          title: this.$t('小区流量计'),
          align: 'center',
          children: [
            {
              title: this.$t('总数'),
              align: 'center',
              dataIndex: 'total3',
            },
            {
              title: this.$t('正常数'),
              align: 'center',
              dataIndex: 'alarm31',
              scopedSlots: { customRender: 'dmaNormal' },
            },
            {
              title: this.$t('警告数'),
              align: 'center',
              dataIndex: 'alarm32',
              scopedSlots: { customRender: 'dmaAbnormal' },
            },
            {
              title: this.$t('严重数'),
              align: 'center',
              dataIndex: 'alarm33',
              scopedSlots: { customRender: 'dmaConnectionAbnormal' },
            },
            {
              title: this.$t('无效数'),
              align: 'center',
              dataIndex: 'alarm30',
            },
          ],
        },
        {
          title: this.$t('日期'),
          align: 'center',
          dataIndex: 'recordDate',
        },
      ]
    },
  },
  methods: {
    loadTopologyParams() {
      const topologyData = Vue.ls.get('GIS_TOPOLOGY_DATA') || {}
      if (topologyData && topologyData.topology) {
        this.CONFIG.Topology = topologyData
        this.CONFIG.TopologyProjection = topologyData.topology.projectCode
        this.CONFIG.TopologyCode = topologyData.topology.code
      }
    },

    async loadData() {
      if (!this.CONFIG.TopologyProjection || !this.CONFIG.TopologyCode) {
        this.$message.warning(this.$t('未获取到拓扑参数，请先选择拓扑'))
        this.dataSource = []
        this.ipagination.total = 0
        return
      }

      this.loading = true
      try {
        const params = {
          projectCode: this.CONFIG.TopologyProjection,
          topologyCode: this.CONFIG.TopologyCode,
        }

        // 如果选择了日期，添加日期参数
        if (this.queryParam.date) {
          params.recordDate = this.queryParam.date
        }

        const res = await getAction(this.url.list, params)

        if (res.success) {
          this.dataSource = res.result || []
          this.ipagination.total = this.dataSource.length
        } else {
          this.dataSource = []
          this.ipagination.total = 0
          this.$message.error(res.message || this.$t('查询失败'))
        }
      } catch (err) {
        console.log(err)
        this.dataSource = []
        this.ipagination.total = 0
        this.$message.error(this.$t('查询异常，请稍后重试'))
      } finally {
        this.loading = false
      }
    },

    searchQuery() {
      this.loadData()
    },

    searchReset() {
      this.queryParam = {}
      this.loadData()
    },
  },
}
</script>
    <style scoped>
@import '~@assets/less/common.less';
</style>